import { useQuery } from "@apollo/client";
import _ from "lodash";

import {
  GET_OWN_OEM_REPORT_BY_ID_QUERY,
  LIST_ALL_OWN_OEM_REPORTS_QUERY,
  GET_OWN_OEM_ANALYTICS,
} from "~/api";

export const useGetAllReports = ({
  limit = 10,
  skip = 0,
  searchQuery,
  skipCondition = false,
  where,
} = {}) => {
  const variables = {
    params: {
      limit,
      skip,
      where: {
        searchQuery,
        ...(where || {}),
      },
    },
  };

  const {
    data: { listAllOwnOemReports = [] } = {},
    loading,
    refetch,
    fetchMore,
  } = useQuery(LIST_ALL_OWN_OEM_REPORTS_QUERY, {
    variables,
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    skip: skipCondition,
  });

  const {
    currentPage,
    limit: itemLimit,
    skip: itemSkip,
    totalCount,
    reports = [],
  } = listAllOwnOemReports;

  const handleFetchMore = ({ limit, skip }) => {
    fetchMore({
      variables: {
        params: {
          limit,
          skip,
          where: {
            searchQuery,
            ...(where || {}),
          },
        },
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return previousResult;
        }

        const mergedReports = [
          ...previousResult.listAllOwnOemReports.reports,
          ...fetchMoreResult.listAllOwnOemReports.reports,
        ];

        const updates = {
          ...previousResult,
          listAllOwnOemReports: {
            ...previousResult.listAllOwnOemReports,
            ...fetchMoreResult.listAllOwnOemReports,
            reports: mergedReports,
          },
        };

        return updates;
      },
    });
  };

  return {
    reports,
    handleFetchMore,
    refetch,
    currentPage,
    limit: itemLimit,
    skip: itemSkip,
    totalCount,
    loading,
  };
};

export const useGetReportByID = ({ id, skipCondition = false }) => {
  const {
    data: getOwnOemReportByID = {},
    loading,
    refetch,
  } = useQuery(GET_OWN_OEM_REPORT_BY_ID_QUERY, {
    variables: {
      id,
    },
    skip: skipCondition,
  });
  return { data: getOwnOemReportByID, loading, refetch };
};

export const useGetAnalytics = ({ input = {}, skipCondition = false }) => {
  const {
    data: getOwnOemAnalytics = {},
    error = {},
    loading,
    refetch,
  } = useQuery(GET_OWN_OEM_ANALYTICS, {
    variables: {
      input,
    },
    skip: _.isEmpty(input) || skipCondition,
  });
  return { analytics: getOwnOemAnalytics, loading, refetch, error };
};
